import {
  BORROWER_ENDPOINTS,
  LENDER_ENDPOINTS,
  USER_ENDPOINTS,
  CONSULTANT_ENDPOINTS
} from "../constants/apiEndpoints";
import { getLocationForPayload } from "../utils/locationUtils";
import { deleteWrapper, getWrapper, getWrapperWeb, postWrapper, postWrapperWeb, putFormDataWrapper, deleteWrapperWeb } from "../utils/Wrapper";

export const updateUser = (userData) => {
  // Get location data from the Redux store
  const locationData = getLocationForPayload();

  // Prepare the payload according to the API requirements
  const data = {
    uuid: userData.uuid,
    name: userData.name,
    phoneNumber: userData.phoneNumber,
    email: userData.email,
    username: userData.username,
    roleId: parseInt(userData.roleId, 10),
    ip: locationData.ip,
    longitude: locationData.longitude,
    latitude: locationData.latitude,
    address: userData.address || "",
    gstin: userData.gstin || "",
    region: userData.region || null,
    area: userData.area || null,
    lendingType: userData.lendingType || null,
    financierType: userData.financierType || null,
    borrowerType: userData.borrowerType || null,
  };

  const url = `${USER_ENDPOINTS.UPDATE}`;
  return postWrapper(url, data);
};

// export const updateUser = async (userData) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }

//     // Get location data from the Redux store
//     const locationData = getLocationForPayload();

//     // Prepare the payload according to the API requirements
//     const requestData = {
//       uuid: userData.uuid,
//       name: userData.name,
//       phoneNumber: userData.phoneNumber,
//       email: userData.email,
//       username: userData.username,
//       roleId: parseInt(userData.roleId, 10),
//       ip: locationData.ip,
//       longitude: locationData.longitude,
//       latitude: locationData.latitude,
//       address: userData.address || "",
//       gstin: userData.gstin || "",
//       region: userData.region || null,
//       area: userData.area || null,
//       lendingType: userData.lendingType || null,
//       financierType: userData.financierType || null,
//       borrowerType: userData.borrowerType || null,
//     };

//     const url = `${API_BASE_URL}${USER_ENDPOINTS.UPDATE}`;
//     const response = await fetch(url, {
//       method: "POST", // Changed from PUT to POST based on the curl example
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//       },
//       body: JSON.stringify(requestData),
//     });

//     if (!response.ok) {
//       try {
//         const errorData = await response.json();
//         toast.error(errorData.responseMessage);
//         throw new Error(
//           errorData.responseMessage ||
//             `Failed to update user: ${response.status}`
//         );
//       } catch (e) {
//         throw new Error(`Failed to update user: ${response.status}`);
//       }
//     }

//     const responseData = await response.json();
//     return responseData;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const deleteUser = (uuid) => {
  let url = `${USER_ENDPOINTS.DELETE_USER}?uuid=${uuid}`;
  return deleteWrapper(url);
};

// export const deleteUser = async (uuid) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }

//     // Using the constant for the delete-user endpoint
//     const url = `${API_BASE_URL}${USER_ENDPOINTS.DELETE_USER}?uuid=${uuid}`;
//     const response = await fetch(url, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//       },
//     });
//     if (!response.ok) {
//       const errorText = await response.text();
//       toast.error(errorText);
//       throw new Error(`Failed to delete user: ${response.status}`);
//     }

//     // Try to parse JSON response, but handle case where response might be empty
//     let data;
//     try {
//       const responseText = await response.text();
//       data = responseText ? JSON.parse(responseText) : { success: true };
//     } catch (e) {
//       data = { success: true };
//     }
//     return data;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getUserById = async (uuid) => {
  let url = `${USER_ENDPOINTS.GET_BY_ID}/${uuid}`;
  return getWrapper(url);
};

// export const getUserById = async (uuid) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }

//     const url = `${API_BASE_URL}${USER_ENDPOINTS.GET_BY_ID}/${uuid}`;
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to fetch user: ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const fetchUsers = (data) => {
  const isPlainObject = (val) => val && val.constructor === Object;
  const incoming = Number.isFinite(data) ? { roleId: data } : (isPlainObject(data) ? data : {});

  const params = new URLSearchParams();
  if (incoming.roleId != null) params.append("roleId", incoming.roleId);
  if (incoming.page != null) params.append("page", incoming.page);
  if (incoming.size != null) params.append("size", incoming.size);
  if (incoming.searchQuery) params.append("searchQuery", incoming.searchQuery);
  if (incoming.sortBy) params.append("sortBy", incoming.sortBy);
  if (incoming.order) params.append("order", incoming.order);

  const query = params.toString();
  let url = `${USER_ENDPOINTS.GET_ALL}${query ? `?${query}` : ""}`;
  return getWrapper(url);
};

export const fetchConsultants = (params = {}) => {
  const { userType = "consultant", status, page, size, sortBy, order, searchQuery } = params;
  const search = new URLSearchParams();
  search.append("userType", userType);
  if (status) search.append("status", status);
  if (Number.isFinite(page)) search.append("page", page);
  if (Number.isFinite(size)) search.append("size", size);
  if (sortBy) search.append("sortBy", sortBy);
  if (order) search.append("order", order);
  if (searchQuery) search.append("searchQuery", searchQuery);
  const url = `${CONSULTANT_ENDPOINTS.GET_ALL}${search.toString() ? `?${search.toString()}` : ""}`;
  return getWrapperWeb(url);
};

export const getConsultantById = (id) => {
  const url = `${CONSULTANT_ENDPOINTS.GET_BY_ID}?id=${id}`;
  return getWrapperWeb(url);
};

export const createConsultant = (data) => {
  const url = `${CONSULTANT_ENDPOINTS.CREATE}`;
  return postWrapperWeb(url, data);
};

export const deleteConsultantById = (id) => {
  const url = `${CONSULTANT_ENDPOINTS.DELETE}?id=${id}`;
  return deleteWrapperWeb(url);
};

export const createUser = (userData) => {
  const data = {
    name: userData.name,
    email: userData.email,
    phoneNumber: userData.phoneNumber,
    username: userData.username,
    roleId: parseInt(userData.roleId, 10),
    region: userData.region || null,
    area: userData.area || null,
    lendingType: userData.lendingType || null,
    financierType: userData.financierType || null,
  };
  let url = `${USER_ENDPOINTS.CREATE}`;
  return postWrapper(url, data);
};

export const getAllRoles = () => {
  let url = "user/get-all-roles";
  return getWrapper(url);
};

export const fetchBorrowers = (params = {}) => {
  const { page, size, searchQuery, sortBy, order } = params;
  const search = new URLSearchParams();
  if (Number.isFinite(page)) search.append("page", page);
  if (Number.isFinite(size)) search.append("size", size);
  if (searchQuery) search.append("searchQuery", searchQuery);
  if (sortBy) search.append("sortBy", sortBy);
  if (order) search.append("order", order);
  const url = `${BORROWER_ENDPOINTS.GET_ALL}${search.toString() ? `?${search.toString()}` : ""}`;
  return getWrapper(url);
};

// export const fetchBorrowers = async () => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }
//     const url = `${API_BASE_URL}${BORROWER_ENDPOINTS.GET_ALL}`;

//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//       },
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       toast.error(errorText);
//       throw new Error(`Failed to fetch borrowers: ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getRegion = () => {
  let url = `${USER_ENDPOINTS.GET_REGION}`;
  return getWrapper(url);
};

// export const getRegion = async () => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }

//     const url = `${API_BASE_URL}${USER_ENDPOINTS.GET_REGION}`;
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to fetch locations: ${response.status}`);
//     }

//     return await response.json();
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getArea = (region) => {
  let url = `${USER_ENDPOINTS.GET_AREA}?region=${region}`;
  return getWrapper(url);
};
// export const getArea = async (region) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }

//     const url = `${API_BASE_URL}${USER_ENDPOINTS.GET_AREA}?region=${region}`;
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to fetch locations: ${response.status}`);
//     }

//     return await response.json();
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const createBorrower = (borrowerData) => {
  // Get location data from the Redux store
  const locationData = getLocationForPayload();

  // Create formData object for multipart/form-data submission
  const formData = new FormData();

  // Add basic borrower details
  formData.append("name", borrowerData.name);
  formData.append("email", borrowerData.email);
  formData.append("mobileNumber", borrowerData.mobileNumber || "");
  formData.append("address", borrowerData.address || "");
  formData.append("gstNumber", borrowerData.gstNumber || "");
  formData.append("userType", "borrower");
  formData.append("borrowerType", borrowerData.borrowerType === "none" ? "individual" : borrowerData.borrowerType || "individual");

  if (borrowerData.borrowerType === "entity") {
    formData.append("entityType", borrowerData.entityType || ""); // company, partnership_firm, or propreitorship_firm
    formData.append("entityName", borrowerData.entityName || "");
  }

  // Add location data
  formData.append("ip", locationData.ip || "");
  formData.append("longitude", locationData.longitude || "");
  formData.append("latitude", locationData.latitude || "");

  // Add file if available
  if (borrowerData.file) {
    formData.append("file", borrowerData.file);
  }

  // const formDataEntries = [...formData.entries()];
  const url = `${BORROWER_ENDPOINTS.CREATE}`;
  return postWrapper(url, formData, { 'Content-Type': 'multipart/form-data' });
};

// export const createBorrower = async (borrowerData) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }

//     // Get location data from the Redux store
//     const locationData = getLocationForPayload();

//     // Create formData object for multipart/form-data submission
//     const formData = new FormData();

//     // Add basic borrower details
//     formData.append("name", borrowerData.name);
//     formData.append("email", borrowerData.email);
//     formData.append("mobileNumber", borrowerData.mobileNumber || "");
//     formData.append("address", borrowerData.address || "");
//     formData.append("gstNumber", borrowerData.gstNumber || "");
//     formData.append("userType", "borrower");
//     formData.append("borrowerType", borrowerData.borrowerType || "individual"); // 'individual' or 'entity'

//     if (borrowerData.borrowerType === "entity") {
//       formData.append("entityType", borrowerData.entityType || ""); // company, partnership_firm, or propreitorship_firm
//       formData.append("entityName", borrowerData.entityName || "");
//     }

//     // Add location data
//     formData.append("ip", locationData.ip || "");
//     formData.append("longitude", locationData.longitude || "");
//     formData.append("latitude", locationData.latitude || "");

//     // Add file if available
//     if (borrowerData.file) {
//       formData.append("file", borrowerData.file);
//     }

//     // const formDataEntries = [...formData.entries()];
//     const url = `${API_BASE_URL}${BORROWER_ENDPOINTS.CREATE}`;
//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//         // Don't set Content-Type header - browser will set it with boundary for multipart/form-data
//       },
//       body: formData,
//     });

//     if (!response.ok) {
//       try {
//         const errorData = await response.json();
//         toast.error(errorData.responseMessage);
//         throw new Error(
//           errorData.responseMessage ||
//             `Failed to create borrower: ${response.status}`
//         );
//       } catch (e) {
//         throw new Error(`Failed to create borrower: ${response.status}`);
//       }
//     }

//     const responseData = await response.json();
//     return responseData;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const updateBorrower = (borrowerData) => {
  const formData = new FormData();

  formData.append("userType", "borrower");
  formData.append("ip", borrowerData.ip || "");
  formData.append(
    "mobileNumber",
    borrowerData.phoneNumber || borrowerData.mobileNumber || ""
  );
  formData.append("name", borrowerData.name || "");
  formData.append("latitude", borrowerData.latitude || "");
  formData.append("longitude", borrowerData.longitude || "");
  formData.append("gstNumber", borrowerData.gstNumber || "");
  formData.append("address", borrowerData.address || "");
  formData.append("uuid", borrowerData.uuid || "");
  formData.append("email", borrowerData.email || "");

  formData.append(
    "borrowerType",
    borrowerData.userType === "none" ? "individual" : borrowerData.userType === "entity" ? "entity" : "individual"
  );

  if (borrowerData.userType === "entity") {
    formData.append("entityType", borrowerData.entityType || "");
    formData.append("entityName", borrowerData.entityName || "");
  }

  // Add file if available
  if (borrowerData.file && borrowerData.file !== "string") {
    formData.append("file", borrowerData.file);
  }
  const url = `${BORROWER_ENDPOINTS.UPDATE}`;
  return putFormDataWrapper(url, formData);
};

// export const updateBorrower = async (borrowerData) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }
//     // Create FormData object instead of JSON
//     const formData = new FormData();

//     formData.append("userType", "borrower");
//     formData.append("ip", borrowerData.ip || "");
//     formData.append("mobileNumber", borrowerData.phoneNumber || borrowerData.mobileNumber || "");
//     formData.append("name", borrowerData.name || "");
//     formData.append("latitude", borrowerData.latitude || "");
//     formData.append("longitude", borrowerData.longitude || "");
//     formData.append("gstNumber", borrowerData.gstNumber || "");
//     formData.append("address", borrowerData.address || "");
//     formData.append("uuid", borrowerData.uuid || "");
//     formData.append("email", borrowerData.email || "");

//     formData.append("borrowerType", borrowerData.userType === "entity" ? "entity" : "individual");

//     if (borrowerData.userType === "entity") {
//       formData.append("entityType", borrowerData.entityType || "");
//       formData.append("entityName", borrowerData.entityName || "");
//     }

//     // Add file if available
//     if (borrowerData.file && borrowerData.file !== "string") {
//       formData.append("file", borrowerData.file);
//     }
//     const url = `${API_BASE_URL}${BORROWER_ENDPOINTS.UPDATE}`;
//     const response = await fetch(url, {
//       method: "PUT",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//         // Don't set Content-Type header - browser will set it with boundary for multipart/form-data
//       },
//       body: formData,
//     });

//     if (!response.ok) {
//       try {
//         const errorData = await response.json();
//         toast.error(errorData.responseMessage);
//         throw new Error(
//           errorData.responseMessage ||
//             `Failed to update borrower: ${response.status}`
//         );
//       } catch (e) {
//         throw new Error(`Failed to update borrower: ${response.status}`);
//       }
//     }

//     const responseData = await response.json();
//     return responseData;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const fetchBorrowerByUuid = (uuid) => {
  let url = `${BORROWER_ENDPOINTS.GET_BY_UUID}?uuid=${uuid}`;
  return getWrapper(url);
};

// export const fetchBorrowerByUuid = async (uuid) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }
//     const url = `${API_BASE_URL}${BORROWER_ENDPOINTS.GET_BY_UUID}?uuid=${uuid}`;
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to fetch borrower: ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     throw error;
//   }
// };

export const deleteBorrower = (uuid) => {
  let url = `${BORROWER_ENDPOINTS.DELETE_BORROWER}?id=${uuid}`;
  return deleteWrapper(url);
};
// export const deleteBorrower = async (uuid) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }
//     const url = `${API_BASE_URL}${BORROWER_ENDPOINTS.DELETE_BORROWER}?id=${uuid}`;
//     const response = await fetch(url, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//       },
//     });
//     if (!response.ok) {
//       const errorText = await response.text();
//       toast.error(errorText);
//       throw new Error(`Failed to delete borrower: ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const getUserByUuid = (uuid) => {
  let url = `${USER_ENDPOINTS.GET_BY_UUID}?uuid=${uuid}`;
  return getWrapper(url);
};

// export const getUserByUuid = async (uuid) => {
//   try {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       throw new Error("Authentication token not found");
//     }
//     const url = `${API_BASE_URL}${USER_ENDPOINTS.GET_BY_UUID}?uuid=${uuid}`;
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         accept: "*/*",
//       },
//     });
//     if (!response.ok) {
//       const errorText = await response.text();
//       toast.error(errorText);
//       throw new Error(`Failed to fetch user by UUID: ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     toast.error(error.message);
//     throw error;
//   }
// };

export const fetchLenders = (params = {}) => {
  const { page, size, sortBy, order, searchQuery } = params;
  const search = new URLSearchParams();
  if (Number.isFinite(page)) search.append("page", page);
  if (Number.isFinite(size)) search.append("size", size);
  if (sortBy) search.append("sortBy", sortBy);
  if (order) search.append("order", order);
  if (searchQuery) search.append("searchQuery", searchQuery);
  const url = `${LENDER_ENDPOINTS.GET_ALL}${search.toString() ? `?${search.toString()}` : ""}`;
  return getWrapper(url);
};

export const getLenderById = (lenderId) => {
  let url = `/lender/get-lender-by-id?id=${lenderId}`;
  return getWrapper(url);
};

export const verifyLender = (userId, lenderId) => {
  let url = `/lender/verify?userId=${userId}&lenderId=${lenderId}`;
  return postWrapper(url);
};

export const updateLender = (lenderData) => {
  const transformedData = {
    id: lenderData.id,
    userType: "lender",
    financialInstitutionType: lenderData.financialInstitutionType,
    financialInstitution: lenderData.financialInstitution,
    typeOfLending: lenderData.typeOfLending,
    typeOfRetailLoans: lenderData.typeOfRetailLoans,
    designation: lenderData.designation,
    userRequest: {
      mobileNumber:
        lenderData.userRequest?.mobileNumber || lenderData.mobileNumber,
      email: lenderData.userRequest?.email || lenderData.email,
      name: lenderData.userRequest?.name || lenderData.name,
    },
    location: lenderData.location,
  };

  let url = `/lender/update`;
  return postWrapper(url, transformedData);
};
export const deleteLender = (id) => {
  let url = `lender/delete/${id}`;
  return deleteWrapper(url);
};

export const createLender = (data) => {
  let url = `${LENDER_ENDPOINTS.CREATE}`;
  return postWrapperWeb(url, data);
};

export const sendOtpFromAdmin = (data) => {
  let url = `/send-otp`;
  return postWrapper(url, data);
};

export const getDashboardData = () => {
  const url = '/dashboard';
  return getWrapper(url);
};


